
import Vue, { PropType } from 'vue';
import { get } from 'lodash';
import Icon, { Icon as IconName } from '@/common/icon/Icon.vue';
import { Theme } from '@/side-bar/side-bar-config.interface';
import Api from '@/core/api';

export default Vue.extend({
    name: 'Stream',

    components: {
        Icon
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        config: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        theme: {
            type: Object as PropType<Theme>,
            default: () => ({})
        },
        noPlayer: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            icon: IconName.playCircle
        };
    },

    computed: {

        hidden(): boolean {
            return get(this, 'config.hidden');
        }
    },

    methods: {
        toggleStreamView() {
            this.api.customAction({ showStream: this.noPlayer }, 'sideBarStream');
        },
    }
});
